const apiUrl = "https://news-app-backend-theta.vercel.app";

export default apiUrl;
